import { DialogProps, useTheme } from "@mui/material"
import { forwardRef } from "react"
import { Dialog } from "./Dialog"

export const FullsizeDialog = forwardRef<HTMLDivElement, DialogProps>((props, ref) => {
    const { spacing } = useTheme()
    return (
        <Dialog
            ref={ref}
            fullWidth
            fullScreen
            PaperProps={{
                sx: {
                    "&.MuiDialog-paper": {
                        position: "absolute",
                        width: "auto",
                        height: "auto",
                        margin: 0,
                        top: 0,
                        bottom: spacing(2),
                        left: spacing(2),
                        right: spacing(2),
                    },
                    ".Dialog-inner": {
                        p: 0,
                    },
                },
            }}
            {...props}
        />
    )
})
